
export const KEY_UP = 38
export const KEY_DOWN = 40
export const KEY_ENTER = 13
export const KEY_BACKSPACE = 8
export const KEY_ESC = 27
